import { useEffect, useState } from "react";
import DEFAULT_PRINT_PARAMETERS from "../const/DefaultPrintParameters"
import validatePrintParameterForm from "../const/PrintParameterFormValidation";

/** 印刷パラメータの入力値用hook */
const usePrintParameterInput = (printSetting) => {
  /** 印刷パラメータの入力値state */
  const [value, setValue] = useState({});
  /** 印刷パラメータの入力値バリデーションstate (trueでOK) */
  const [isValidForm, setValidForm] = useState(true);

  /** 帳票ID変更時、入力値のデフォルトを切り換える */
  useEffect(() => {
    setDefaultPrintParameter(printSetting.Value.reportTypeId);
  }, [printSetting.Value.reportTypeId]);

  /** 入力変更時、バリデーションを行う */
  useEffect(() => {
    setValidForm(validatePrintParameterForm(printSetting, value));
  }, [value]);

  const setDefaultPrintParameter = (reportTypeId) => {
    setValue(DEFAULT_PRINT_PARAMETERS[reportTypeId] || null);
  }

  const setPropValue = (propName, value) => {
    setValue((prev) => ({...prev, [propName]: value}));
  }

  return {
    value,
    setValue,
    setPropValue,
    isValidForm,
    targetDate: printSetting.Value.targetDate
  };
}

export default  usePrintParameterInput;

